import { useAdminUpdate } from '@reapitform/hooks'
import { AdminFormField, AdminFormFieldPayload } from '../types'

/** Updates a form field (`PUT /api/review-card-sections/{sectionRef}/fields/{fieldRef}`). */
export const useUpdateAdminFormField = (sectionReferenceID: string, fieldReferenceID: string) =>
  useAdminUpdate<AdminFormFieldPayload, AdminFormField>({
    path: `/api/review-card-sections/${sectionReferenceID}/fields/${fieldReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the field',
    successMessage: 'Field updated',
  })
